import { configureStore } from '@reduxjs/toolkit';
import blogReducer from './blog/blogSlice';
import authReducer from './auth/authSlice';
import metricReducer from './metrics/metricSlice';
import clinicReducer from './clinic/clinicSlice'
import therapistReducer from './therapist/therapistSlice'
import invitationReducer from './invitation/invitationSlice';
import practiceReducer from './practice/practiceSlice';
import filterReducer from './therapist/filterSlice';
import resourcesReducer from './resources/resourcesSlice';
import searchReducer from './therapist/matchmakingSlise';
import userReducer from './user/userSlice';
import campaignReducer from './campaign/campaignSlice';
import scraperSlice from './scraper/scraperSlice';
import integrationReducer from './integration/integrationSlice';
import referralReducer from './referral/referralSlice';
import billingReducer from './billing/billingSlice';
import stripeReducer from './stripe/stripeSlice';
import supportReducer from './support/supportSlice';
import analyticReducer from './analytics/analyticSlice';

const store = configureStore({
    reducer: {
        blog: blogReducer,
        auth: authReducer,
        metrics: metricReducer,
        clinics: clinicReducer,
        therapist: therapistReducer,
        invitation: invitationReducer,
        practices: practiceReducer,
        filters: filterReducer,
        resources: resourcesReducer,
        search: searchReducer,
        user: userReducer,
        campaign: campaignReducer,
        scraper: scraperSlice,
        integration: integrationReducer,
        referral: referralReducer,
        billing: billingReducer,
        stripe: stripeReducer,
        support: supportReducer,
        analytic: analyticReducer,
    },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export default store;
